<script lang="ts">
  import ErrorWarningAlertIcon from '$icons/ErrorWarningAlertIcon.svelte';

  export let items: { [key: string]: string | number | boolean }[] = [];
  export let errors: string[] = [];
  export let size: 'sm' | 'md' = 'sm';
  export let label = '';
  export let description = '';
  export let value: string | number | boolean = true;
</script>

<!-- TODO make this a radio group -->
<div>
  <div>
    <p class="font-architekt text-gray-dark-12 text-sm font-normal leading-5">
      {label}
    </p>
    <p class="mb-sm text-gray-dark-11 text-xs">
      {description}
    </p>
  </div>
  <div class="gap-x-xs bg-gray-dark-1 p-3xs mt-2 flex w-full items-center">
    {#if items?.length > 0}
      {#each items as item}
        {@const [key, itemValue] = Object.entries(item)?.[0]}
        <button
          type="button"
          class:sm={size === 'sm'}
          class:md={size === 'md'}
          class:active={value === itemValue}
          class="text-gray-dark-11 flex flex-1 items-center justify-center border border-transparent text-sm font-medium leading-4 ring-[3px] ring-transparent"
          on:click={() => (value = itemValue)}
        >
          {key}
        </button>
      {/each}
    {/if}
  </div>
  {#if errors?.length > 0}
    {#each errors as error}
      {#if error}
        <div class="text-red-dark-10 mt-2 flex items-center justify-start gap-x-1 gap-y-0.5">
          <ErrorWarningAlertIcon />
          <p class="text-red-dark-10">{error}</p>
        </div>
      {/if}
    {/each}
  {/if}
</div>

<!-- Hidden element used for form submission -->
<input type="hidden" name="value" {value} />

<style lang="postcss">
  .sm {
    @apply h-8;
  }
  .md {
    @apply h-10;
  }
  button:hover {
    @apply text-gray-dark-12;
  }
  button:focus {
    @apply border-mint-dark-8 ring-mint-dark-4 rounded;
  }
  .active {
    @apply border-mint-dark-8 bg-mint-dark-2 text-mint-dark-11 rounded;
  }
</style>
